import { useQuery } from '@tanstack/react-query';

import type { TStaffSession } from '@/services/auth';

import { STAFF_KEYS } from '@/constants/queryKeys';
import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

const useStaffSession = () => {
  return useQuery<TStaffSession>({
    queryKey: STAFF_KEYS.session(),
    queryFn: async () => errorUtils.unwrap(await authService.readStaffSession()),
    staleTime: 0,
  });
};

export {
  useStaffSession,
};
